import { commonViewTexts } from '../common';

const targetName = commonViewTexts.user;

export const deleteUserDialogViewTexts = {
  title: targetName,
  message: (userName: string) => [
    `${targetName}「${userName}」を削除します。`,
    'この操作は取り消すことができません。'
  ]
} as const;
